import Permissions from '@app/src/auth/permissions'
import type { NavigationItemProps } from '@app/src/components/Navigation/VerticalMenu/NavigationItems/NavigationItems'
import navigationLinks from '@app/src/wf-constants/navigationLinks'
import React from 'react'
import { useIntl } from 'react-intl'
import type { MenuLinkWrapperProps } from './MenuWrapper'
import { MenuLinkWrapper } from './MenuWrapper'

const SubscriptionLink: React.FC<NavigationItemProps> = ({ icon }) => {
  const { formatMessage } = useIntl()

  const menuItems: MenuLinkWrapperProps['menuItems'] = {
    link: navigationLinks.transparencySubscriptions,
    permission: [Permissions.TRANSPARENCY_USER],
  }

  return <MenuLinkWrapper icon={icon} menuItems={menuItems} title={formatMessage({ id: 'navbar.subscribers' })} />
}

export default SubscriptionLink
